/**
 * CancelledScreen.tsx
 * Search cancelled screen
 */

import { type FC } from 'react';

import { Button } from '@skillarea/lib-frontend';
import { Title, TextBlock } from '@skillarea/lib-frontend';
import { useTranslation } from 'react-i18next';

import styles from '../MatchmakingModal.module.scss';

import { translateMatchmakingError } from '~/lib/matchmakingLocale';

export interface ICancelledScreenProps {
  message?: string;
  onFindNewOpponent: () => void;
}

export const CancelledScreen: FC<ICancelledScreenProps> = ({
  message,
  onFindNewOpponent,
}) => {
  const { t } = useTranslation('matchmaking');
  const displayMessage = translateMatchmakingError(
    t,
    message ?? 'Your search has been cancelled',
  );

  return (
    <div className={styles.screen}>
      <div className={`${styles.centered} ${styles.resultScreen}`}>
        <div className={styles.resultIcon}>
          <span className={styles.emoji}>✕</span>
        </div>

        <TextBlock className={styles.resultText} size="l">
          {displayMessage}
        </TextBlock>

        <Title className={styles.resultTitle} color="contrast" variant="benzin">
          {t('search.cancelledTitle')}
        </Title>
      </div>

      <div className={styles.footer}>
        <div className={styles.actionButtons}>
          <Button
            className={styles.actionButton}
            color="accent"
            name={t('result.findNewOpponent')}
            onClick={onFindNewOpponent}
            size="s"
            variant="filled"
          >
            {t('result.findNewOpponent')}
          </Button>
        </div>
      </div>
    </div>
  );
};
